import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { LoadingService } from './services/loading.service';
import { MaterialModule } from './material.module';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MaterialModule, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'myfxpool';
  private baseUrl = `${environment.apiUrl}`;

  env: string = 'prod';

  constructor(
    public loadingService: LoadingService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.http.get<any>(`${this.baseUrl}/env`).subscribe((res: any) => {
      this.env = res.env;
    });
  }

}
